<template>
    <div class="absolute w-full top-0 left-0 z-30 axios-overlayer" :class="loading ? 'loading' : ''">
        <div class="absolute w-full h-full left-0 top-0 bg-white" :class="opacity ? 'opacity-90' : ''"></div>
        <svg :class="positionClass" class="left-1/2 top-1/2 animate-spin -ml-2.5 -mt-2.5 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    </div>
</template>

<script>
import {watch} from "vue";

export default {
    props:{
        loading:{
            Boolean,
            default: false
        },
        opacity:{
            Boolean,
            default: true
        },
        positionClass:{
            String,
            default: 'fixed'
        }
    },
    setup(props){
        watch(
            () => props.loading,
            (loading) => {

                const body = document.body;

                if(loading){
                    body.classList.add('overflow-hidden');
                } else {
                    body.classList.remove('overflow-hidden');
                }
            }
        );
    }
}
</script>

<style scoped>

.axios-overlayer{
    height: 0;
    opacity: 0;
    -webkit-transition: height 0s ease-out 0.3s, opacity 0.3s ease;
    -moz-transition: height 0s ease-out 0.3s, opacity 0.3s ease;
    -o-transition: height 0s ease-out 0.3s, opacity 0.3s ease;
    transition: height 0s ease-out 0.3s, opacity 0.3s ease;
}
.axios-overlayer.loading{
    height: 100%;
    opacity: 1;
    -webkit-transition: height 0s ease-out, opacity 0.3s ease;
    -moz-transition: height 0s ease-out, opacity 0.3s ease;
    -o-transition: height 0s ease-out, opacity 0.3s ease;
    transition: height 0s ease-out, opacity 0.3s ease;
}
</style>
